<div class="min-h-screen bg-gray-50 p-4 md:p-6" *ngIf="paymentLink">
    <!-- Header -->
    <div class="mb-6">
        <button (click)="goBack()"
            class="flex items-center gap-2 text-gray-600 hover:text-gray-900 mb-4 transition-colors">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
            </svg>
            Volver a la lista
        </button>

        <div class="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
            <div>
                <h1 class="text-2xl font-bold text-gray-900">Detalle del Link de Pago</h1>
                <p class="text-gray-500 mt-1">ID Wompi: {{ paymentLink.wompiLinkId }}</p>
            </div>
            <div class="flex items-center gap-2">
                <span class="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium"
                    [ngClass]="getStatusClass()">
                    {{ getStatusText() }}
                </span>
            </div>
        </div>
    </div>

    <div class="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <!-- Información Principal -->
        <div class="lg:col-span-2 space-y-6">
            <!-- Link de Pago -->
            <div class="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
                <h3 class="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
                    <svg class="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
                    </svg>
                    Link de Pago
                </h3>

                <div class="bg-gray-50 rounded-lg p-4 mb-4">
                    <div class="flex items-center gap-2">
                        <input type="text" [value]="paymentLink.paymentUrl" readonly
                            class="flex-1 bg-white border border-gray-200 rounded-lg px-3 py-2 text-sm text-gray-700">
                        <button (click)="copyToClipboard()"
                            class="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors flex items-center gap-1">
                            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3" />
                            </svg>
                            Copiar
                        </button>
                        <button (click)="openPaymentLink()"
                            class="px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors flex items-center gap-1">
                            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                            </svg>
                            Abrir
                        </button>
                    </div>
                </div>

                <div *ngIf="paymentLink.isActive && !paymentLink.isExpired" class="mt-4">
                    <button (click)="deactivatePaymentLink()"
                        class="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors flex items-center gap-1">
                        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636" />
                        </svg>
                        Desactivar Link
                    </button>
                </div>
            </div>

            <!-- Información de Montos -->
            <div class="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
                <h3 class="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
                    <svg class="w-5 h-5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    Información de Pago
                </h3>

                <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                        <span class="text-sm text-gray-500">Monto (COP)</span>
                        <p class="text-xl font-bold text-gray-900">{{ formatCurrency(paymentLink.amount, 'COP') }}</p>
                    </div>
                    <div *ngIf="paymentLink.originalAmount">
                        <span class="text-sm text-gray-500">Monto Original</span>
                        <p class="text-xl font-bold text-gray-900">{{ formatCurrency(paymentLink.originalAmount,
                            paymentLink.currencyCode) }}</p>
                    </div>
                    <div>
                        <span class="text-sm text-gray-500">Moneda</span>
                        <p class="text-lg text-gray-900">{{ paymentLink.currencyName }} ({{ paymentLink.currencyCode }})
                        </p>
                    </div>
                    <div *ngIf="paymentLink.exchangeRate">
                        <span class="text-sm text-gray-500">Tasa de Cambio</span>
                        <p class="text-lg text-gray-900">{{ paymentLink.exchangeRate | number:'1.2-4' }}</p>
                    </div>
                </div>
            </div>

            <!-- Beneficiario -->
            <div class="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
                <h3 class="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
                    <svg class="w-5 h-5 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                    </svg>
                    Beneficiario
                </h3>

                <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                        <span class="text-sm text-gray-500">Tipo</span>
                        <p class="text-lg text-gray-900">{{ paymentLink.planType }}</p>
                    </div>
                    <div *ngIf="paymentLink.participantName">
                        <span class="text-sm text-gray-500">Participante</span>
                        <p class="text-lg text-gray-900">{{ paymentLink.participantName }}</p>
                    </div>
                    <div *ngIf="paymentLink.participantDocument">
                        <span class="text-sm text-gray-500">Documento</span>
                        <p class="text-lg text-gray-900">{{ paymentLink.participantDocument }}</p>
                    </div>
                    <div *ngIf="paymentLink.participantEmail">
                        <span class="text-sm text-gray-500">Email</span>
                        <p class="text-lg text-gray-900">{{ paymentLink.participantEmail }}</p>
                    </div>
                    <div *ngIf="paymentLink.companyName">
                        <span class="text-sm text-gray-500">Empresa</span>
                        <p class="text-lg text-gray-900">{{ paymentLink.companyName }}</p>
                    </div>
                    <div *ngIf="paymentLink.companyNit">
                        <span class="text-sm text-gray-500">NIT</span>
                        <p class="text-lg text-gray-900">{{ paymentLink.companyNit }}</p>
                    </div>
                </div>

                <!-- Accesos Directos -->
                <div class="mt-4 pt-4 border-t border-gray-200">
                    <span class="text-sm text-gray-500 block mb-2">Accesos Directos</span>
                    <div class="flex flex-wrap gap-2">
                        <!-- Ver Perfil Participante -->
                        <a *ngIf="paymentLink.participantId"
                            [href]="'/dashboard/participants/profile-participant/' + paymentLink.participantId" target="_blank"
                            class="inline-flex items-center gap-1 px-3 py-1.5 bg-purple-50 text-purple-700 rounded-lg hover:bg-purple-100 transition-colors text-sm font-medium">
                            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                            </svg>
                            Ver Participante
                            <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                            </svg>
                        </a>
                        <!-- Ver Perfil Empresa -->
                        <a *ngIf="paymentLink.companyId" [href]="'/dashboard/companies/view/' + paymentLink.companyId"
                            target="_blank"
                            class="inline-flex items-center gap-1 px-3 py-1.5 bg-indigo-50 text-indigo-700 rounded-lg hover:bg-indigo-100 transition-colors text-sm font-medium">
                            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                            </svg>
                            Ver Empresa
                            <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                            </svg>
                        </a>
                        <!-- Ver Inscripción Individual -->
                        <a *ngIf="paymentLink.enrollmentId"
                            [href]="'/dashboard/enrollments/view-v2/' + paymentLink.enrollmentId" target="_blank"
                            class="inline-flex items-center gap-1 px-3 py-1.5 bg-blue-50 text-blue-700 rounded-lg hover:bg-blue-100 transition-colors text-sm font-medium">
                            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                            </svg>
                            Ver Inscripción
                            <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                            </svg>
                        </a>
                        <!-- Ver Inscripción Corporativa -->
                        <a *ngIf="paymentLink.corporateAgreementId"
                            [href]="'/dashboard/enrollments/corporate/view-v2/' + paymentLink.corporateAgreementId"
                            target="_blank"
                            class="inline-flex items-center gap-1 px-3 py-1.5 bg-blue-50 text-blue-700 rounded-lg hover:bg-blue-100 transition-colors text-sm font-medium">
                            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                            </svg>
                            Ver Inscripción Corporativa
                            <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                            </svg>
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <!-- Sidebar -->
        <div class="space-y-6">
            <!-- Fechas -->
            <div class="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
                <h3 class="text-lg font-semibold text-gray-900 mb-4">Fechas</h3>

                <div class="space-y-3">
                    <div>
                        <span class="text-sm text-gray-500">Generación</span>
                        <p class="text-gray-900">{{ formatDate(paymentLink.generatedDate) }}</p>
                    </div>
                    <div>
                        <span class="text-sm text-gray-500">Vencimiento</span>
                        <p class="text-gray-900" [ngClass]="{'text-red-600': paymentLink.isExpired}">
                            {{ formatDate(paymentLink.expirationDate) }}
                        </p>
                    </div>
                    <div *ngIf="paymentLink.webhookProcessed">
                        <span class="text-sm text-gray-500">Webhook Procesado</span>
                        <p class="text-gray-900">{{ formatDate(paymentLink.webhookDate) }}</p>
                    </div>
                </div>
            </div>

            <!-- Proyecto -->
            <div class="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
                <h3 class="text-lg font-semibold text-gray-900 mb-4">Proyecto</h3>

                <!-- Con datos de proyecto -->
                <div *ngIf="paymentLink.projectName" class="space-y-3">
                    <div>
                        <span class="text-sm text-gray-500">Nombre</span>
                        <p class="text-gray-900">{{ paymentLink.projectName }}</p>
                    </div>
                    <div *ngIf="paymentLink.projectCode">
                        <span class="text-sm text-gray-500">Código</span>
                        <p class="text-gray-900">{{ paymentLink.projectCode }}</p>
                    </div>
                    <div *ngIf="paymentLink.quotaNumber">
                        <span class="text-sm text-gray-500">Cuota</span>
                        <p class="text-gray-900">#{{ paymentLink.quotaNumber }}</p>
                    </div>
                    <div>
                        <span class="text-sm text-gray-500">Estado Plan</span>
                        <p class="text-gray-900">{{ paymentLink.paymentStatus || '-' }}</p>
                    </div>
                </div>

                <!-- Sin datos de proyecto -->
                <div *ngIf="!paymentLink.projectName" class="text-center py-4">
                    <p class="text-sm text-gray-400 italic">Sin proyecto asociado</p>
                    <p class="text-xs text-gray-400 mt-1">
                        Este link puede haber sido generado sin una inscripción activa
                    </p>
                </div>

                <!-- Acceso Directo al Proyecto -->
                <div *ngIf="paymentLink.projectId" class="mt-4 pt-4 border-t border-gray-200">
                    <a [href]="'/dashboard/projects/view-project/' + paymentLink.projectId" target="_blank"
                        class="inline-flex items-center gap-1 px-3 py-1.5 bg-emerald-50 text-emerald-700 rounded-lg hover:bg-emerald-100 transition-colors text-sm font-medium">
                        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z" />
                        </svg>
                        Ver Proyecto
                        <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                        </svg>
                    </a>
                </div>
            </div>

            <!-- Información Técnica -->
            <div class="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
                <h3 class="text-lg font-semibold text-gray-900 mb-4">Información Técnica</h3>

                <div class="space-y-3 text-sm">
                    <div>
                        <span class="text-gray-500">ID Local</span>
                        <p class="text-gray-900 font-mono">{{ paymentLink.id }}</p>
                    </div>
                    <div>
                        <span class="text-gray-500">SKU</span>
                        <p class="text-gray-900 font-mono text-xs break-all">{{ paymentLink.sku }}</p>
                    </div>
                    <div>
                        <span class="text-gray-500">Email Enviado</span>
                        <p class="text-gray-900">{{ paymentLink.emailSent ? 'Sí' : 'No' }}</p>
                    </div>
                    <div>
                        <span class="text-gray-500">Webhook Procesado</span>
                        <p class="text-gray-900">{{ paymentLink.webhookProcessed ? 'Sí' : 'No' }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Modal de Confirmación -->
<app-confirmation-modal [isVisible]="showConfirmationModal" [config]="confirmationConfig"
    (confirmed)="onConfirmDeactivation()" (cancelled)="onCancelDeactivation()">
</app-confirmation-modal>